import { Size, SizeableText, Typography } from 'fronton-react';
import React from 'react';

export const AdaptiveTypography = ({
  variant,
  size,
  text,
}: {
  variant: SizeableText;
  size: Size;
  text: string;
}) => (
  <Typography variant={variant} size={size} color="text-primary">
    {text}
  </Typography>
);
